let employeeTable = [
  {
    label: "姓名",
    prop: "name",
    sortable: 1
  },
  {
    label: "编号",
    prop: "userId"
  },
  {
    label: "所属单位",
    prop: "departmentName"
  },
  // {
  //   label: "参加工作时间",
  //   prop: "joinTime"
  // },
  // {
  //   label: "进入单位时间",
  //   prop: "enterTime"
  // },
  {
    label: "登录账号",
    prop: "username"
  },
  // {
  //   label: "是否参加考核",
  //   prop: "participate"
  // },
  // {
  //   label: "状态",
  //   prop: "state"
  // },
  // {
  //   label: "身份",
  //   prop: "roleId"
  // },
  // {
  //   label: "联系方式",
  //   prop: "phoneNum"
  // }
]

let employeeList = [
  {
    name: "张三",
    participate: 1,
    roleId: 100,
    state: "在职",
    username: "10000",
    joinTime: "2022-03-14",
    enterTime: "2022-03-23",
    departmentId: 101,
    departmentName: "科技部",
    userId: 10000
  },
]


export {
  employeeTable,
  employeeList
}